export enum BaseRoutes {
  StudentNew = 'student',
  Methodist = 'methodist',
  CuratorNew = 'curator',
  HeadTeacher = 'headTeacher',
  Teacher = 'teacher',
  Admin = 'admin',
  Calendar = 'calendar',
  Catalogues = 'catalogue',
  CataloguesWithOpenBasket = 'openBasket',
  MobileApp = 'mobile-app',
  Manager = 'manager',
  Announcements = 'announcements',
  InternalManager = 'manager/prolongation',
  LANDING = 'landing',
  SOFT_REGISTRATION = 'soft-registration',
  StudentRegistration = 'student-registration',
}

export enum CommonRoutes {
  Registration = 'registration',
  Authorization = 'authorization',
  Auth = 'auth',
  Profile = 'profile',
  ResetPassword = 'password-recover',
  ShortURL = 'shorturl',
}

export enum StudentRoutes {
  Main = 'main',
  AllTasks = 'all-tasks',
  Archive = 'archive',
  Education = 'education',
  Theory = 'theory',
  Homework = 'homework',
  WorkOnMistakes = 'work-on-mistakes',
  Task = 'task',
  Quiz = 'quiz',
  Oral = 'oral',
  Test = 'test',
  TestStart = 'start',
  Rating = 'rating',
  ScoresDetails = 'scores-details',
  Text = 'text',
  FoldersView = 'folders-view',
  Lecture = 'lecture',
  Faq = 'faq',
  RulesAgreements = 'rules-agreements',
  Unts = 'unts',
  EventReport = 'event-report',
  CareerGuidance = 'career-guidance',
  Notifications = 'notifications',
  ChanceToAdmission = 'chance-to-admission',
}

export enum MethodistRoutes {
  Main = 'main',
  Course = 'course',
  Lesson = 'lesson',
  Homework = 'homework',
  Test = 'test',
  QuizBank = 'quiz-bank',
  Teachers = 'teachers',
}

export enum CuratorRoutes {
  Main = 'main',
  Profile = 'profile',
  MyTasks = 'my-tasks',
  Announcement = 'announcement',
  Test = 'test',
  FoldersControl = 'folders-control',
  StudentProgress = 'student-progress',
  StudentList = 'student-list',
  Archive = 'archive',
  Rating = 'rating',
  Unt = 'unt',
  Surveys = 'surveys',
  RatingPage = ':surveyId/:courseId',
  Reviews = 'reviews',
}

export enum CalendarRoutes {
  MAIN = '',
}

export enum CataloguesRoutes {
  MAIN = '',
  FAQ = 'faq',
  ORDER = 'order',
  ORDER_MOBILE = 'mobile-app/order',
  ORDER_RESULT = 'order/:result',
  COURSE_DETAIL = 'course/:courseId',
}

export enum AdminRoutes {
  Users = 'users',
  UserCreate = 'users/create',
  Curators = 'curators',
  Impersonation = 'impersonation',
  Subjects = 'subjects',
  Catalogue = 'catalogue',
  ManagersMonthly = 'managers/monthly',
  ManagersList = 'managers/list',
  Payments = 'payments',
  Statistic = 'statistic',
  Banner = 'banner',
  Faq = 'faq',
  Stories = 'stories',
  Profile = 'profile',
  Announcement = 'announcement',
  Discounts = 'discounts',
  Prolongation = 'prolongation',
  PromoCodes = 'promo-codes',
  EmptyPage = 'empty-page',
  Posters = 'posters',
  UNT = 'unt',
  Surveys = 'surveys',
  SurveysCuratorTeacher = 'surveys/curator-teacher',
  CuratorTeacher = 'curator-teacher',
  CuratorDetails = 'curator-teacher/curator',
  TeacherDetails = 'curator-teacher/teacher',
  SurveysNPS = 'surveys/nps',
  NPS = 'nps',
  General = 'general',
  NPSGeneral = 'nps/general',
  NPSSurveyById = 'nps/:surveyId',
  NPSDetails = 'nps/:surveyId/:product',
  List = 'list',
  Report = 'report',
  Rating = 'rating',
  CuratorsReport = 'report/curators',
  TeachersReport = 'report/teachers',
  SubjectsRating = 'rating/subjects',
  TeachersRating = 'rating/teachers',
  CAREER_GUIDANCE_STATS = 'career-guidance-stats',
  MBTI = 'mbti',
  INTELLIGENCE_TYPE = 'intelligence-type',
  PROFESSION = 'profession',
  AI_PROFESSION = 'ai-profession',
  IDP = 'idp',
  EGOGRAM = 'egogram-dimension',
}

export enum HeadTeacherRoutes {
  Catalogue = 'catalogue',
  Subjects = 'subjects',
  GroupRating = 'group/:groupId',
  SubjectDetail = 'subjects/:subjectId',
  SubjectGroups = 'subjects/:subjectId/:courseId',
  SubjectCourseEdit = 'subjects/:groupId/:subjectId/:id/edit/:padding',
  SubjectGroupsDetail = 'subjects/:subjectId/:courseId/:groupId/:curatorId/:padding',
  Faq = 'faq',
  Profile = 'profile',
  Banner = 'banner',
  Announcement = 'announcement',
  Analytics = 'analytics',
  StreamVideos = 'stream-videos',
  QuestionnaireCreate = 'questionnaire-create',
  QuestionnaireRoled = 'questionnaire-roled/:id',
  QuestionnaireTable = 'questionnaire-table',
  QuestionnaireDetailed = 'questionnaire-detailed',
  QuestionnaireHistory = 'questionnaire-history',
  Performance = 'performance',
  Unt = 'unt',
}

export enum ManagerRoutes {
  Payments = 'payments',
  Discounts = 'discounts',
  Profile = 'profile',
  Prolongation = 'prolongation',
  CRM = 'crm',
  ROP = 'rop',
}

export enum DocumentRoutes {
  PublicOffer = 'public-offer',
  PrivacyPolicy = 'privacy-policy',
}
